// src/components/shared/CustomAvatar.js
import React from 'react';
import {useChannelStateContext, useMessageContext} from 'stream-chat-react';
import '../../styles/CustomAvatar.css';
import UserPhoto from './UserPhoto';

const CustomAvatar = ({shouldShowAvatar, timeThreshold}) => {
    const { message, isMyMessage, threadList } = useMessageContext();
    const user = message?.user;
    const alignmentClass = isMyMessage() ? 'avatarchat--left' : 'avatarchat--right';
    const { messages, threadMessages } = useChannelStateContext();

    // Select the correct message list (thread or main) and find the index of the current message.
    const messageList = threadList ? threadMessages : messages;
    const messageIndex = messageList.findIndex(m => m.id === message.id);

    // Only show avatar for messages not sent by the current user
    if (isMyMessage()) {
        return null;
    }

    return shouldShowAvatar && shouldShowAvatar(messageList, messageIndex, timeThreshold) ? (
        <div className={`${alignmentClass}`}>
            <UserPhoto
                photo={user?.photo}
                firstName={user?.firstName || user?.name?.split(' ')[0] || ''}
                lastName={user?.lastName || user?.name?.split(' ')[1] || ''}
                 sharedFirstName={user?.sharedFirstName|| user?.name?.split(' ')[1] || ''}
                sharedLastName={user?.sharedLastName || user?.name?.split(' ')[1] || ''}
            />
        </div>
    ) : (
        <div className="custom-avatar-fallback"></div>
    );
};

export default CustomAvatar;